import type {ReactElement} from 'react';
import type {PreviewAssetIconProps} from './preview-asset-icon.types';
import styles from './preview-asset-icon.module.scss';

export function PreviewAssetIcon({iconPath}: PreviewAssetIconProps): ReactElement {
  return (
    <span className={styles.assetIconSlot}>
      <img alt="" aria-hidden="true" className={styles.assetIcon} src={window.PMW.util.asset_url(iconPath)} />
    </span>
  );
}
